import { StoreProduct } from '@bofrak-backend/shared';

export interface SyncStatus {
  status: SyncResponseStatus;
  progress?: number;
  total?: number;
  message?: string;
  error?: string;
  lastSync?: Date;
  productsLoaded?: number;
}

export interface WebSocketStatus {
  connected: boolean;
  reconnectAttempts: number;
  lastHeartbeat?: Date;
  lastUpdate?: Date;
}

export enum SyncMessageType {
  INITIAL_SYNC = 'INITIAL_SYNC',
  REFRESH_SYNC = 'REFRESH_SYNC',
  STOP_SYNC = 'STOP_SYNC',
  PROCESS_PRODUCTS = 'PROCESS_PRODUCTS',
}

export enum SyncResponseType {
  SYNC_STARTED = 'SYNC_STARTED',
  SYNC_PROGRESS = 'SYNC_PROGRESS',
  SYNC_COMPLETE = 'SYNC_COMPLETE',
  SYNC_ERROR = 'SYNC_ERROR',
  SYNC_STATUS = 'SYNC_STATUS',
}

export enum SyncResponseStatus {
  IDLE = 'idle',
  SYNCING = 'syncing',
  ERROR = 'error',
}

export interface SyncMessage {
  type: SyncMessageType;
  payload: {
    storeId: string;
    merchantId: string;
    includeDeleted?: boolean;
    apiEndpoint: string;
    accessToken?: string;
    products?: StoreProduct[];
    isComplete?: boolean;
  };
}

export interface SyncResponse {
  type: SyncResponseType;
  payload: {
    status?: SyncResponseStatus;
    progress?: number;
    total?: number;
    message?: string;
    error?: string;
    productsLoaded?: number;
    lastSync?: Date;
  };
}

export interface StoreProductSyncOptions {
  storeId: string;
  merchantId: string;
  apiEndpoint: string;
  accessToken?: string;
  includeDeleted?: boolean;
  autoSync?: boolean;
  parentsOnly?: boolean;
}

export interface StoreProductsState {
  products: StoreProduct[];
  syncStatus: SyncStatus;
  isInitialLoad: boolean;
}
